/* Guías de escribir y enviar. Ver el contrato de campos en ../guides.js */

export const GUIDES_WRITING = [
  {
    slug: 'translate-emails',
    id: 'translate',
    category: 'writing',
    icon: 'languages',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'traduir', 'traducir', 'translate', 'idioma', 'inglés', 'anglès', 'english', 'francés',
      'alemán', 'no entiendo el correo', 'no entenc', 'está en otro idioma', 'responder en inglés',
      'traducción', 'traducció',
    ],
    ca: {
      title: 'Entendre un correu en un altre idioma i respondre-hi',
      lead: 'Un botó per llegir-lo en el teu idioma i una frase per contestar en el seu.',
      answer:
        'Amb el correu obert, prem “Tradueix” a la barra de sota: el text passa al teu idioma i pots tornar a l’original quan vulguis. Per contestar, digues a l’assistent “respon-li en anglès” (o l’idioma que sigui) i escriurà la resposta directament en aquell idioma.',
      steps: [
        {
          t: 'Obre el correu',
          d: 'Encara que no n’entenguis ni una paraula, obre’l normalment.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Prem “Tradueix”',
          d: 'És un dels botons de la barra de sota del missatge. El text es queda al mateix lloc, però en el teu idioma.',
          screen: 'reader',
          highlight: 'actions',
        },
        {
          t: 'Torna a l’original si vols',
          d: 'Al capdamunt del text traduït hi ha l’enllaç “Mostra l’original”. No es perd res.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Contesta en el seu idioma',
          d: 'Demana-ho al xat: “respon-li en anglès dient que la comanda surt dilluns”. Nukli detecta l’idioma del fil i escriu en aquell.',
          screen: 'chat',
          highlight: 'input',
        },
      ],
      tips: [
        'Nukli treballa amb més de 40 idiomes, i manté el to: un correu formal continua sent formal traduït.',
        'També pots escriure la resposta en català i demanar-li “tradueix-ho a l’alemany abans d’enviar”.',
      ],
      faq: [
        {
          q: 'La traducció canvia el correu original?',
          a: 'No. El missatge del servidor es queda tal com era; només canvia el que veus a la pantalla.',
        },
      ],
    },
    es: {
      title: 'Entender un correo en otro idioma y responderlo',
      lead: 'Un botón para leerlo en tu idioma y una frase para contestar en el suyo.',
      answer:
        'Con el correo abierto, pulsa “Traducir” en la barra de abajo: el texto pasa a tu idioma y puedes volver al original cuando quieras. Para contestar, dile al asistente “respóndele en inglés” (o el idioma que sea) y escribirá la respuesta directamente en ese idioma.',
      steps: [
        {
          t: 'Abre el correo',
          d: 'Aunque no entiendas ni una palabra, ábrelo normalmente.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Pulsa “Traducir”',
          d: 'Es uno de los botones de la barra de debajo del mensaje. El texto se queda en el mismo sitio, pero en tu idioma.',
          screen: 'reader',
          highlight: 'actions',
        },
        {
          t: 'Vuelve al original si quieres',
          d: 'Encima del texto traducido está el enlace “Mostrar original”. No se pierde nada.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Contesta en su idioma',
          d: 'Pídelo en el chat: “respóndele en inglés diciendo que el pedido sale el lunes”. Nukli detecta el idioma del hilo y escribe en él.',
          screen: 'chat',
          highlight: 'input',
        },
      ],
      tips: [
        'Nukli trabaja con más de 40 idiomas y mantiene el tono: un correo formal sigue siendo formal traducido.',
        'También puedes escribir la respuesta en castellano y pedirle “tradúcelo al alemán antes de enviar”.',
      ],
      faq: [
        {
          q: '¿La traducción cambia el correo original?',
          a: 'No. El mensaje del servidor se queda tal cual; solo cambia lo que ves en la pantalla.',
        },
      ],
    },
    en: {
      title: 'Understanding an email in another language and replying',
      lead: 'One button to read it in your language, one sentence to answer in theirs.',
      answer:
        'With the email open, press “Translate” in the bar below: the text switches to your language and you can go back to the original whenever you want. To answer, tell the assistant “reply in Spanish” (or whichever language) and it writes the reply straight in that language.',
      steps: [
        {
          t: 'Open the email',
          d: 'Even if you cannot read a word of it, open it as usual.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Press “Translate”',
          d: 'One of the buttons in the bar under the message. The text stays where it is, but in your language.',
          screen: 'reader',
          highlight: 'actions',
        },
        {
          t: 'Go back to the original if you like',
          d: 'Above the translated text there is a “Show original” link. Nothing is lost.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Answer in their language',
          d: 'Ask in the chat: “reply in Spanish saying the order ships on Monday”. Nukli detects the thread language and writes in it.',
          screen: 'chat',
          highlight: 'input',
        },
      ],
      tips: [
        'Nukli handles more than 40 languages and keeps the tone: a formal email stays formal in translation.',
        'You can also write the reply in English and say “translate it to German before sending”.',
      ],
      faq: [
        {
          q: 'Does translating change the original email?',
          a: 'No. The message on the server stays exactly as it was; only what you see changes.',
        },
      ],
    },
  },

  {
    slug: 'check-before-sending',
    id: 'proofread',
    category: 'writing',
    icon: 'spell-check',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'faltes', 'faltas', 'ortografía', 'ortografia', 'corregir', 'spelling', 'grammar', 'proofread',
      'revisar antes de enviar', 'gramática', 'me da vergüenza escribir mal', 'corrector',
    ],
    ca: {
      title: 'Revisar faltes i to abans d’enviar',
      lead: 'Una passada de mig segon perquè no marxi cap “grasias” ni cap frase que soni més seca del que volies.',
      answer:
        'A la caixa de resposta hi ha el botó de revisió (“Corregeix”). El prems i Nukli et marca faltes, gramàtica, puntuació i frases millorables. Pots acceptar-les d’una en una o totes de cop, o enviar-ho igualment.',
      steps: [
        {
          t: 'Escriu la resposta',
          d: 'Escriu-la com et surti; ja la polirem després.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'Prem el botó de correcció',
          d: 'A la barra d’eines de la caixa de resposta. Té forma de “ABC” amb una marca.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'Mira els suggeriments',
          d: 'Cada un diu de quin tipus és: ortografia, gramàtica, puntuació o estil. Els pots ignorar un a un.',
        },
        {
          t: 'Accepta i envia',
          d: '“Modifica” canvia un suggeriment; “Modifica-ho tot” els aplica tots. També pots prémer “Envia igualment”.',
          screen: 'reply',
          highlight: 'toolbar',
        },
      ],
      tips: [
        'Pots triar l’idioma del corrector a la mateixa barra, útil si escrius en dos idiomes.',
        'Si vols canviar el to i no les faltes, selecciona el text i fes servir l’edició ràpida.',
      ],
      faq: [
        {
          q: 'M’ho canviarà tot sense preguntar?',
          a: 'No. Els suggeriments es queden marcats fins que tu decideixis, un a un o tots de cop.',
        },
      ],
    },
    es: {
      title: 'Revisar faltas y tono antes de enviar',
      lead: 'Una pasada de medio segundo para que no se escape ningún “haber” ni ninguna frase más seca de lo que querías.',
      answer:
        'En la caja de respuesta está el botón de revisión (“Corregir”). Lo pulsas y Nukli te marca faltas, gramática, puntuación y frases mejorables. Puedes aceptarlas una a una o todas de golpe, o enviar igualmente.',
      steps: [
        {
          t: 'Escribe la respuesta',
          d: 'Escríbela como te salga; ya la puliremos después.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'Pulsa el botón de corrección',
          d: 'En la barra de herramientas de la caja de respuesta. Tiene forma de “ABC” con una marca.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'Mira las sugerencias',
          d: 'Cada una dice de qué tipo es: ortografía, gramática, puntuación o estilo. Puedes ignorarlas una a una.',
        },
        {
          t: 'Acepta y envía',
          d: '“Modificar” cambia una sugerencia; “Modificar todo” las aplica todas. También puedes pulsar “Enviar igualmente”.',
          screen: 'reply',
          highlight: 'toolbar',
        },
      ],
      tips: [
        'Puedes elegir el idioma del corrector en la misma barra, útil si escribes en dos idiomas.',
        'Si lo que quieres es cambiar el tono y no las faltas, selecciona el texto y usa la edición rápida.',
      ],
      faq: [
        {
          q: '¿Me lo cambiará todo sin preguntar?',
          a: 'No. Las sugerencias se quedan marcadas hasta que tú decidas, una a una o todas de golpe.',
        },
      ],
    },
    en: {
      title: 'Checking spelling and tone before you send',
      lead: 'A half-second pass so no typo escapes and no sentence lands drier than you meant.',
      answer:
        'The reply box has a check button (“Check”). Press it and Nukli marks spelling, grammar, punctuation and sentences worth improving. Accept them one by one or all at once, or send anyway.',
      steps: [
        {
          t: 'Write the reply',
          d: 'Write it however it comes out; we will polish it after.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'Press the check button',
          d: 'In the toolbar of the reply box. It looks like “ABC” with a tick.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'Look at the suggestions',
          d: 'Each one says what kind it is: spelling, grammar, punctuation or style. You can ignore them individually.',
        },
        {
          t: 'Accept and send',
          d: '“Modify” applies one suggestion; “Modify all” applies the lot. You can also press “Send anyway”.',
          screen: 'reply',
          highlight: 'toolbar',
        },
      ],
      tips: [
        'You can pick the checker’s language in the same bar, handy if you write in two languages.',
        'If what you want is a change of tone rather than spelling, select the text and use quick edit.',
      ],
      faq: [
        {
          q: 'Will it change everything without asking?',
          a: 'No. Suggestions stay marked until you decide, one at a time or all together.',
        },
      ],
    },
  },

  {
    slug: 'dictate-with-your-voice',
    id: 'dictation',
    category: 'writing',
    icon: 'mic',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'dictar', 'veu', 'voz', 'voice', 'dictation', 'micrófono', 'micròfon', 'hablar', 'parlar',
      'escribir hablando', 'no me gusta teclear', 'me cuesta escribir a máquina',
    ],
    ca: {
      title: 'Dictar el correu parlant',
      lead: 'Si el teclat se’t fa pesat, digues-ho en veu alta i que ho escrigui ell.',
      answer:
        'A la barra d’eines de la caixa de resposta hi ha un botó amb un micròfon. Prem-lo, parla amb naturalitat i torna’l a prémer per aturar. El text que has dit apareix escrit i el pots corregir com qualsevol altre.',
      steps: [
        {
          t: 'Obre la resposta',
          d: 'Prem “Respon” en un correu, o obre un correu nou.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'Prem el micròfon',
          d: 'És a la barra d’eines de la caixa. La primera vegada l’ordinador et demanarà permís per fer servir el micròfon: digues que sí.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'Parla amb calma',
          d: 'No cal dictar la puntuació: parla com parlaries per telèfon. Fes frases senceres i no t’allunyis massa del micròfon.',
        },
        {
          t: 'Atura i revisa',
          d: 'Torna a prémer el botó. El text apareix a la caixa. Repassa’l i, si vols, passa-hi el corrector.',
          screen: 'reply',
          highlight: 'toolbar',
        },
      ],
      tips: [
        'També pots dictar i després demanar a l’assistent: “posa-ho més formal i arregla-ho”.',
        'Si el botó no reacciona, mira els permisos de micròfon del sistema (a Mac: Configuració > Privacitat > Micròfon).',
      ],
      faq: [
        {
          q: 'On es queda la meva veu?',
          a: 'S’utilitza per transcriure-la a text i prou. El que queda desat és el text del correu, com si l’haguessis teclejat.',
        },
      ],
    },
    es: {
      title: 'Dictar el correo hablando',
      lead: 'Si el teclado se te hace pesado, dilo en voz alta y que lo escriba él.',
      answer:
        'En la barra de herramientas de la caja de respuesta hay un botón con un micrófono. Púlsalo, habla con naturalidad y vuelve a pulsarlo para parar. Lo que has dicho aparece escrito y lo puedes corregir como cualquier otro texto.',
      steps: [
        {
          t: 'Abre la respuesta',
          d: 'Pulsa “Responder” en un correo, o abre un correo nuevo.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'Pulsa el micrófono',
          d: 'Está en la barra de herramientas de la caja. La primera vez el ordenador te pedirá permiso para usar el micrófono: di que sí.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'Habla con calma',
          d: 'No hace falta dictar la puntuación: habla como hablarías por teléfono. Haz frases enteras y no te alejes demasiado del micrófono.',
        },
        {
          t: 'Para y revisa',
          d: 'Vuelve a pulsar el botón. El texto aparece en la caja. Repásalo y, si quieres, pásale el corrector.',
          screen: 'reply',
          highlight: 'toolbar',
        },
      ],
      tips: [
        'También puedes dictar y luego pedirle al asistente: “ponlo más formal y arréglalo”.',
        'Si el botón no reacciona, mira los permisos de micrófono del sistema (en Mac: Ajustes > Privacidad > Micrófono).',
      ],
      faq: [
        {
          q: '¿Dónde se queda mi voz?',
          a: 'Se usa para transcribirla a texto y ya está. Lo que se guarda es el texto del correo, como si lo hubieras tecleado.',
        },
      ],
    },
    en: {
      title: 'Dictating your email out loud',
      lead: 'If typing is a chore, say it out loud and let the app write it.',
      answer:
        'The reply box toolbar has a microphone button. Press it, speak naturally, press it again to stop. What you said appears as text and you can edit it like anything else.',
      steps: [
        {
          t: 'Open the reply',
          d: 'Press “Reply” on an email, or start a new one.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'Press the microphone',
          d: 'It is in the toolbar of the box. The first time, your computer will ask permission to use the microphone: say yes.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'Speak calmly',
          d: 'You do not have to dictate punctuation: talk as you would on the phone. Use whole sentences and stay near the microphone.',
        },
        {
          t: 'Stop and check',
          d: 'Press the button again. The text appears in the box. Read it over and run the checker if you like.',
          screen: 'reply',
          highlight: 'toolbar',
        },
      ],
      tips: [
        'You can also dictate and then ask the assistant: “make it more formal and tidy it up”.',
        'If the button does nothing, check your system microphone permissions (on Mac: Settings > Privacy > Microphone).',
      ],
      faq: [
        {
          q: 'What happens to my voice?',
          a: 'It is used to turn speech into text, and that is it. What gets saved is the email text, as if you had typed it.',
        },
      ],
    },
  },

  {
    slug: 'reply-templates',
    id: 'templates',
    category: 'writing',
    icon: 'copy',
    level: 'medium',
    plan: 'free',
    minutes: 3,
    topics: [
      'plantilla', 'plantillas', 'template', 'templates', 'respuesta repetida', 'resposta repetida',
      'siempre contesto lo mismo', 'sempre contesto el mateix', 'guardar respuesta', 'reutilizar',
    ],
    ca: {
      title: 'Plantilles: les respostes que repeteixes cada setmana',
      lead: 'Desa una vegada la resposta de sempre i que l’assistent l’adapti a cada correu nou.',
      answer:
        'Quan tinguis una resposta que repeteixes, digues-ho a l’assistent: “desa aquesta resposta com a plantilla amb el nom Pressupostos”. Més endavant, en un correu semblant, digues-li “fes servir la plantilla de pressupostos” i l’adaptarà a aquell correu concret.',
      steps: [
        {
          t: 'Escriu (o genera) la resposta bona',
          d: 'La que et serveix per a molts correus: el pressupost tipus, la resposta de vacances, les instruccions d’enviament.',
          screen: 'reply',
          highlight: 'box',
        },
        {
          t: 'Demana-li que la desi',
          d: 'Al xat: “desa això com a plantilla i digues-li Pressupost estàndard”. Queda desada al teu compte.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Fes-la servir més endavant',
          d: 'Amb un correu semblant obert: “contesta amb la plantilla del pressupost”. La llegeix i l’adapta al que demana aquesta persona.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Revisa i envia',
          d: 'Com sempre: l’esborrany queda a la caixa i el botó d’enviar el prems tu.',
          screen: 'reply',
          highlight: 'box',
        },
      ],
      tips: [
        'Pregunta “quines plantilles tinc?” i te les llista.',
        'La gràcia no és enganxar el mateix text: és que el text base s’adapti al nom, la data i la petició de cada correu.',
      ],
      faq: [
        {
          q: 'Enviarà la plantilla tal qual?',
          a: 'La fa servir com a base i l’ajusta al correu. Tu la llegeixes abans d’enviar-la, com sempre.',
        },
      ],
    },
    es: {
      title: 'Plantillas: las respuestas que repites cada semana',
      lead: 'Guarda una vez la respuesta de siempre y deja que el asistente la adapte a cada correo nuevo.',
      answer:
        'Cuando tengas una respuesta que repites, díselo al asistente: “guarda esta respuesta como plantilla con el nombre Presupuestos”. Más adelante, en un correo parecido, dile “usa la plantilla de presupuestos” y la adaptará a ese correo concreto.',
      steps: [
        {
          t: 'Escribe (o genera) la respuesta buena',
          d: 'La que te sirve para muchos correos: el presupuesto tipo, la respuesta de vacaciones, las instrucciones de envío.',
          screen: 'reply',
          highlight: 'box',
        },
        {
          t: 'Pídele que la guarde',
          d: 'En el chat: “guarda esto como plantilla y llámala Presupuesto estándar”. Queda guardada en tu cuenta.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Úsala más adelante',
          d: 'Con un correo parecido abierto: “contesta con la plantilla del presupuesto”. La lee y la adapta a lo que pide esa persona.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Revisa y envía',
          d: 'Como siempre: el borrador se queda en la caja y el botón de enviar lo pulsas tú.',
          screen: 'reply',
          highlight: 'box',
        },
      ],
      tips: [
        'Pregunta “¿qué plantillas tengo?” y te las lista.',
        'La gracia no es pegar el mismo texto: es que el texto base se adapte al nombre, la fecha y la petición de cada correo.',
      ],
      faq: [
        {
          q: '¿Enviará la plantilla tal cual?',
          a: 'La usa como base y la ajusta al correo. Tú la lees antes de enviarla, como siempre.',
        },
      ],
    },
    en: {
      title: 'Templates: the replies you repeat every week',
      lead: 'Save your standard answer once, and let the assistant fit it to each new email.',
      answer:
        'When you have a reply you keep repeating, tell the assistant: “save this reply as a template called Quotes”. Later, on a similar email, say “use the quotes template” and it adapts it to that particular message.',
      steps: [
        {
          t: 'Write (or generate) the good reply',
          d: 'The one that works for many emails: the standard quote, the holiday reply, the shipping instructions.',
          screen: 'reply',
          highlight: 'box',
        },
        {
          t: 'Ask it to save it',
          d: 'In the chat: “save this as a template and call it Standard quote”. It is stored on your account.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Use it later',
          d: 'With a similar email open: “reply using the quote template”. It reads it and adapts it to what this person is asking.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Check and send',
          d: 'As always: the draft sits in the box and you press send.',
          screen: 'reply',
          highlight: 'box',
        },
      ],
      tips: [
        'Ask “what templates do I have?” and it lists them.',
        'The point is not pasting the same text: it is that the base text adapts to each email’s name, date and request.',
      ],
      faq: [
        {
          q: 'Will it send the template as-is?',
          a: 'It uses it as a base and adjusts it to the email. You read it before sending, as always.',
        },
      ],
    },
  },

  {
    slug: 'schedule-send',
    id: 'schedule-send',
    category: 'writing',
    icon: 'clock',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'programar enviament', 'programar envío', 'schedule send', 'enviar más tarde', 'enviar demà',
      'enviar mañana', 'send later', 'hora de envío', 'no enviar ahora', 'cancelar envío programado',
    ],
    ca: {
      title: 'Programar un enviament per a més tard',
      lead: 'Escriu-lo ara de matinada i que arribi demà a les nou, com si t’haguessis llevat d’hora.',
      answer:
        'Amb la resposta escrita, demana-ho a l’assistent: “envia això demà al matí”. També pots fer servir el botó de programar de la caixa de resposta i triar hora. Els enviaments programats surten encara que tinguis la app tancada.',
      steps: [
        {
          t: 'Escriu el correu',
          d: 'A mà o amb l’assistent: tant se val.',
          screen: 'reply',
          highlight: 'foot',
        },
        {
          t: 'Tria quan ha de sortir',
          d: 'Hi ha opcions ràpides (aquesta tarda, demà al matí, dilluns) i també pots triar dia i hora exactes.',
          screen: 'schedule',
          highlight: 'presets',
        },
        {
          t: 'Confirma',
          d: 'Nukli et diu quan sortirà. El correu queda a la llista d’enviaments programats.',
          screen: 'schedule',
          highlight: 'confirm',
        },
        {
          t: 'Anul·la’l si canvies d’idea',
          d: 'A la llista de programats hi ha el botó de cancel·lar. Només funciona si encara no ha marxat.',
        },
      ],
      tips: [
        'Molt útil per no escriure a algú a les dues de la matinada i quedar estrany.',
        'Es té en compte la teva hora local, així que “demà al matí” vol dir el teu matí.',
      ],
      faq: [
        {
          q: 'He de deixar l’ordinador encès?',
          a: 'No. L’enviament programat surt del servidor de Nukli, encara que tanquis la app.',
        },
        {
          q: 'I si ja ha sortit?',
          a: 'Llavors ja no es pot cancel·lar: t’ho dirà clarament.',
        },
      ],
    },
    es: {
      title: 'Programar un envío para más tarde',
      lead: 'Escríbelo ahora de madrugada y que llegue mañana a las nueve, como si te hubieras levantado pronto.',
      answer:
        'Con la respuesta escrita, pídeselo al asistente: “envía esto mañana por la mañana”. También puedes usar el botón de programar de la caja de respuesta y elegir hora. Los envíos programados salen aunque tengas la app cerrada.',
      steps: [
        {
          t: 'Escribe el correo',
          d: 'A mano o con el asistente: da igual.',
          screen: 'reply',
          highlight: 'foot',
        },
        {
          t: 'Elige cuándo tiene que salir',
          d: 'Hay opciones rápidas (esta tarde, mañana por la mañana, el lunes) y también puedes elegir día y hora exactos.',
          screen: 'schedule',
          highlight: 'presets',
        },
        {
          t: 'Confirma',
          d: 'Nukli te dice cuándo saldrá. El correo queda en la lista de envíos programados.',
          screen: 'schedule',
          highlight: 'confirm',
        },
        {
          t: 'Anúlalo si cambias de idea',
          d: 'En la lista de programados está el botón de cancelar. Solo funciona si todavía no ha salido.',
        },
      ],
      tips: [
        'Muy útil para no escribirle a alguien a las dos de la madrugada y quedar raro.',
        'Se tiene en cuenta tu hora local, así que “mañana por la mañana” es tu mañana.',
      ],
      faq: [
        {
          q: '¿Tengo que dejar el ordenador encendido?',
          a: 'No. El envío programado sale del servidor de Nukli aunque cierres la app.',
        },
        {
          q: '¿Y si ya ha salido?',
          a: 'Entonces ya no se puede cancelar: te lo dirá claramente.',
        },
      ],
    },
    en: {
      title: 'Scheduling a send for later',
      lead: 'Write it at midnight and let it land at nine, as though you were an early riser.',
      answer:
        'Once the reply is written, ask the assistant: “send this tomorrow morning”. You can also use the schedule button in the reply box and pick a time. Scheduled emails go out even with the app closed.',
      steps: [
        {
          t: 'Write the email',
          d: 'By hand or with the assistant, it makes no difference.',
          screen: 'reply',
          highlight: 'foot',
        },
        {
          t: 'Choose when it should go',
          d: 'There are quick options (this afternoon, tomorrow morning, Monday) and you can also pick an exact date and time.',
          screen: 'schedule',
          highlight: 'presets',
        },
        {
          t: 'Confirm',
          d: 'Nukli tells you when it will leave. The email waits in the scheduled list.',
          screen: 'schedule',
          highlight: 'confirm',
        },
        {
          t: 'Cancel if you change your mind',
          d: 'The scheduled list has a cancel button. It only works while the email has not gone out yet.',
        },
      ],
      tips: [
        'Very handy for not emailing someone at two in the morning.',
        'It uses your local time, so “tomorrow morning” means your morning.',
      ],
      faq: [
        {
          q: 'Do I have to leave the computer on?',
          a: 'No. Scheduled sends go out from Nukli’s server even if you close the app.',
        },
        {
          q: 'What if it already went?',
          a: 'Then it cannot be cancelled, and it says so plainly.',
        },
      ],
    },
  },

  {
    slug: 'attachments',
    id: 'attachments',
    category: 'writing',
    icon: 'paperclip',
    level: 'basic',
    plan: 'free',
    minutes: 3,
    topics: [
      'adjunt', 'adjuntar', 'adjunto', 'attachment', 'attach', 'archivo', 'arxiu', 'file', 'pdf',
      'foto', 'descargar adjunto', 'no encuentro el archivo', 'me mandaron un pdf', 'enviar un fichero',
    ],
    ca: {
      title: 'Adjuntar arxius i trobar els que t’han enviat',
      lead: 'Enganxar un PDF, guardar la foto que t’han passat i localitzar aquell document de fa mesos.',
      answer:
        'Per adjuntar, arrossega l’arxiu a sobre de la caixa de resposta o fes servir el botó del clip. Per baixar-ne un que t’han enviat, ves al final del correu i prem-hi. I si no el trobes, demana-ho a l’assistent: també busca dins dels PDF.',
      steps: [
        {
          t: 'Per adjuntar: arrossega o prem el clip',
          d: 'Pots arrossegar l’arxiu des de l’escriptori fins a la caixa de resposta, o fer servir el botó del clip de la barra d’eines.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'Per baixar-ne un: ves al final del correu',
          d: 'Els adjunts surten sota el text, amb el nom i la mida. Prem-hi per obrir-lo o baixar-lo.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Demana-li a l’assistent que l’adjunti',
          d: '“Adjunta el pressupost que em van enviar el mes passat”: el busca entre els teus correus i el posa a la resposta.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Busca dins dels documents',
          d: 'La cerca de Nukli mira també el contingut dels PDF i documents rebuts, no només l’assumpte.',
          screen: 'inbox',
          highlight: 'search',
        },
      ],
      tips: [
        'Frases útils: “què deia el PDF de la factura?”, “busca’m el contracte que em van enviar al març”.',
        'Si l’arxiu és molt gran, molts proveïdors el rebutgen: envia’l amb un enllaç a un servei de fitxers.',
      ],
      faq: [
        {
          q: 'Puc llegir un adjunt sense baixar-lo?',
          a: 'Sí, molts es poden previsualitzar dins la mateixa app.',
        },
      ],
    },
    es: {
      title: 'Adjuntar archivos y encontrar los que te han enviado',
      lead: 'Pegar un PDF, guardar la foto que te han pasado y localizar aquel documento de hace meses.',
      answer:
        'Para adjuntar, arrastra el archivo encima de la caja de respuesta o usa el botón del clip. Para descargar uno que te han enviado, ve al final del correo y púlsalo. Y si no lo encuentras, pídeselo al asistente: también busca dentro de los PDF.',
      steps: [
        {
          t: 'Para adjuntar: arrastra o pulsa el clip',
          d: 'Puedes arrastrar el archivo desde el escritorio hasta la caja de respuesta, o usar el botón del clip de la barra de herramientas.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'Para descargar uno: ve al final del correo',
          d: 'Los adjuntos salen debajo del texto, con su nombre y tamaño. Púlsalo para abrirlo o descargarlo.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Pídele al asistente que lo adjunte',
          d: '“Adjunta el presupuesto que me mandaron el mes pasado”: lo busca entre tus correos y lo pone en la respuesta.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Busca dentro de los documentos',
          d: 'La búsqueda de Nukli mira también el contenido de los PDF y documentos recibidos, no solo el asunto.',
          screen: 'inbox',
          highlight: 'search',
        },
      ],
      tips: [
        'Frases útiles: “¿qué decía el PDF de la factura?”, “búscame el contrato que me enviaron en marzo”.',
        'Si el archivo es muy grande, muchos proveedores lo rechazan: mándalo con un enlace a un servicio de ficheros.',
      ],
      faq: [
        {
          q: '¿Puedo leer un adjunto sin descargarlo?',
          a: 'Sí, muchos se pueden previsualizar dentro de la propia app.',
        },
      ],
    },
    en: {
      title: 'Attaching files and finding the ones you were sent',
      lead: 'Adding a PDF, saving the photo someone sent you, and tracking down that document from months ago.',
      answer:
        'To attach, drag the file onto the reply box or use the paperclip button. To download one you were sent, go to the end of the email and click it. And if you cannot find it, ask the assistant: it searches inside PDFs too.',
      steps: [
        {
          t: 'To attach: drag it in or press the paperclip',
          d: 'Drag the file from your desktop onto the reply box, or use the paperclip in the toolbar.',
          screen: 'reply',
          highlight: 'toolbar',
        },
        {
          t: 'To download one: go to the end of the email',
          d: 'Attachments sit below the text with their name and size. Click to open or download.',
          screen: 'reader',
          highlight: 'body',
        },
        {
          t: 'Ask the assistant to attach it',
          d: '“Attach the quote they sent me last month”: it finds it among your emails and puts it in the reply.',
          screen: 'chat',
          highlight: 'input',
        },
        {
          t: 'Search inside documents',
          d: 'Nukli’s search also looks at the contents of PDFs and documents you have received, not just the subject.',
          screen: 'inbox',
          highlight: 'search',
        },
      ],
      tips: [
        'Handy phrases: “what did the invoice PDF say?”, “find the contract they sent me in March”.',
        'If the file is very large, many providers reject it: send a link to a file service instead.',
      ],
      faq: [
        {
          q: 'Can I read an attachment without downloading it?',
          a: 'Yes, many can be previewed inside the app.',
        },
      ],
    },
  },
];
